import Vue from 'vue'
import { reportError } from '@zhenguo/jssdk/owl'

function formatComponentName(vm: Vue) {
  if (!vm) return 'anonymous'
  if (vm.$root === vm) {
    return 'root instance'
  }
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  )
}

export default {
  install(app: typeof Vue) {
    // quit if Vue isn't on the page
    if (!app || !app.config) return
    app.config.errorHandler = function errorHandler(error, vm: Vue, info, ...extra) {
      reportError(
        error || {
          name: '未知错误',
        },
        {
          tags: {
            componentName: formatComponentName(vm),
            // propsData: vm && vm.$options.propsData,
            info,
          },
        },
      )
      console.error.apply(null, [error, vm, info, ...extra])
    }
    app.config.warnHandler = function (msg, vm, trace, ...extra) {
      // quit if Vue isn't on the page
      if (!app || !app.config) return
      // `trace` 是组件的继承关系追踪
      reportError(
        { name: 'warn', msg },
        {
          level: 'warn',
          tags: {
            componentName: formatComponentName(vm), // propsData: vm && vm.$options.propsData,
            trace,
          },
        },
      )
      console.warn.apply(null, [msg, vm, trace, ...extra])
    }
  },
}
